if (!customElements.get('article-premium')) {
  customElements.define(
    'article-premium',
    class ArticlePremium extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-article-content]');
        this.initProgress();
        this.initToc();
        this.initCopy();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.observer) this.observer.disconnect();
      }

      /* Reading progress: how far through the article body the reader is */
      initProgress() {
        const bar = document.querySelector('[data-article-progress]');
        if (!bar || !this.content) return;
        let ticking = false;
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const rect = this.content.getBoundingClientRect();
            const total = rect.height - window.innerHeight * 0.6;
            const read = Math.min(Math.max(-rect.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
            bar.style.transform = `scaleX(${total > 0 ? read / total : 0})`;
            ticking = false;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      /* "In this article": built from the article's h2 / h3 headings */
      initToc() {
        const wrap = this.querySelector('[data-toc-wrap]');
        const list = this.querySelector('[data-toc]');
        if (!wrap || !list || !this.content) return;

        const headings = Array.from(this.content.querySelectorAll('h2, h3'));
        if (headings.length < 2) return;

        const used = new Set();
        const links = headings.map((heading, index) => {
          if (!heading.id) {
            let slug = heading.textContent
              .trim()
              .toLowerCase()
              .replace(/[^\w\s-]/g, '')
              .replace(/\s+/g, '-')
              .slice(0, 60) || `section-${index + 1}`;
            while (used.has(slug) || document.getElementById(slug)) slug += `-${index + 1}`;
            heading.id = slug;
          }
          used.add(heading.id);

          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          if (heading.tagName === 'H3') link.classList.add('is-sub');
          item.append(link);
          list.append(item);
          return link;
        });
        wrap.hidden = false;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const index = headings.indexOf(entry.target);
              links.forEach((link, i) => link.classList.toggle('is-active', i === index));
            });
          },
          { rootMargin: '0px 0px -70% 0px' }
        );
        headings.forEach((heading) => this.observer.observe(heading));
      }

      initCopy() {
        const button = this.querySelector('[data-copy-link]');
        if (!button) return;
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(button.dataset.copyLink);
          } catch (error) {
            /* still show the message */
          }
          const toast = this.querySelector('[data-article-toast]');
          if (!toast) return;
          toast.textContent = button.dataset.copied;
          toast.hidden = false;
          clearTimeout(this.toastTimer);
          this.toastTimer = setTimeout(() => (toast.hidden = true), 2200);
        });
      }
    }
  );
}
